import { connect } from 'react-redux';

import { getItemsList } from '../../Items/itemsActions';
// import { getOrganizationMembersList } from '../../../Projects/projectsActions';
import {
  clearOfficeDetails,
  createOffice,
  getOfficeDetails,
  getPublicZoneList,
  updateOffice,
} from '../officesActions';
import CreateUpdateOffice from './CreateUpdateOffice';

const mapStateToProps = state => ({
  publicZoneList: state.office.publicZoneList,

  addOrUpdateOfficeLoading: state.office.addOrUpdateOfficeLoading,
  officeDetails: state.office.officeDetails,
  officeCreateUpdateSuccess: state.office.officeCreateUpdateSuccess,
  itemsList: state.items.itemsList,
  officeDetails: state.office.officeDetails,
  isDetailsLoading: state.office.isDetailsLoading,
});

const mapDispatchToProps = dispatch => ({
  createOffice: payload => dispatch(createOffice(payload)),
  updateOffice: payload => dispatch(updateOffice(payload)),
  clearOfficeDetails: () => dispatch(clearOfficeDetails()),
  getPublicZoneList: params => dispatch(getPublicZoneList(params)),
  getItemsList: () => dispatch(getItemsList()),
  getOfficeDetails: params => dispatch(getOfficeDetails(params)),
});

export default connect(mapStateToProps, mapDispatchToProps)(CreateUpdateOffice);
